var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldLock = function SvgShieldLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.592 1.633a2.25 2.25 0 0 0-1.184 0l-6.75 1.841A2.25 2.25 0 0 0 3 5.645v10.031c0 .77.393 1.485 1.042 1.898l6.75 4.296a2.25 2.25 0 0 0 2.416 0l6.75-4.296A2.25 2.25 0 0 0 21 15.676V5.646a2.25 2.25 0 0 0-1.658-2.172l-6.75-1.84Zm-.79 1.448a.75.75 0 0 1 .395 0l6.75 1.84a.75.75 0 0 1 .553.724v10.031a.75.75 0 0 1-.347.633l-6.75 4.295a.75.75 0 0 1-.806 0l-6.75-4.295a.75.75 0 0 1-.347-.633V5.646a.75.75 0 0 1 .553-.724l6.75-1.841Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 10.5V9a2.75 2.75 0 1 1 5.5 0v1.5H15c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25H9c-.69 0-1.25-.56-1.25-1.25v-3.5c0-.69.56-1.25 1.25-1.25h.25Zm1 0h3.5V9a1.75 1.75 0 1 0-3.5 0v1.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13.375,
    r: 0.625
  })));
};
export default SvgShieldLock;